import { Menu, UnstyledButton, Text } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

/** Language picker (Romanian default, English available). Choice is remembered. */
export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage === 'en' ? 'en' : 'ro';

  return (
    <Menu position="bottom-end" withinPortal>
      <Menu.Target>
        <UnstyledButton
          aria-label={t('lang.label')}
          style={{ display: 'flex', alignItems: 'center', gap: 6, padding: compact ? 4 : 6 }}
        >
          <IconLanguage size={18} />
          <Text size="sm">{current.toUpperCase()}</Text>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={() => void i18n.changeLanguage('ro')}>{t('lang.ro')}</Menu.Item>
        <Menu.Item onClick={() => void i18n.changeLanguage('en')}>{t('lang.en')}</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
